export const UPDATE_TORCH_JSON = 'UPDATE_TORCH_JSON'

export function torchJsonReducer (state = {}, action) {
    switch (action.type){
        case UPDATE_TORCH_JSON:
            return action.payload
        default: return state
    }
}